// extracted by mini-css-extract-plugin
export default {"root":"gXuqUDMHCfIn256n5uZf","title":"gO4pfJPzlYd20Vt9oaBQ"};